export default {
  serverURI: '',
  fixedLayout: false,
  hideLogoOnMobile: false,
  project: 'sd112021',
  loginNameProject: 'BIODIGESTOR COPACOL',
  sideNameProject: 'BIO COPACOL',
  exibirGraficoInicial: true,
  iconeInterno: '../static/img/logocopacol.svg',
  graficoSeteDias: {
    titulo: 'Geração de Energia a partir do dia ',
    label: 'Energia (Kw/h)',
    parametroG1: 'Gerador1PotenciaAcumulada',
    buscarG1: true,
    parametroG2: 'Gerador2PotenciaAcumulada',
    buscarG2: true,
    parametroG3: 'Gerador3PotenciaAcumulada',
    buscarG3: true,
    parametroG4: 'Gerador4PotenciaAcumulada',
    buscarG4: true,
    parametroG5: 'Gerador5PotenciaAcumulada',
    buscarG5: false,
    parametroG6: 'Gerador6PotenciaAcumulada',
    buscarG6: false
  },
  idioma: 'Pt-Br'
}



// WEBPACK FOOTER //
// ./src/config/index.js